// import { Link } from "react-router-dom"
import Header from '../common/Header';
export default function AuthLayout({ children }) {
  return (
    <>
      <Header/>
      {children}
    </>
  );
}